import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IonCol, IonRow } from '@ionic/angular/standalone';
import { SharedModule } from 'src/app/components/shared/shared.module';
import { DownloadNoteComponent } from './download-note/download-note.component';
import { FromToDateComponent } from './from-to-date/from-to-date.component';
import { ReportFormatComponent } from './report-format/report-format.component';

@NgModule({
  declarations: [
    DownloadNoteComponent,
    ReportFormatComponent,
    FromToDateComponent,
  ],
  imports: [CommonModule, SharedModule, ReactiveFormsModule, IonRow, IonCol],
  exports: [DownloadNoteComponent, FromToDateComponent, ReportFormatComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedReportsModule {}
